import { StyleSheet, Image, View, ImageSourcePropType } from 'react-native';

import { Location } from '../../api/search';
import Colors from '../../constants/Colors';
import { useLocation } from '../../contexts/locations';
import useColorScheme from '../../hooks/useColorScheme';
import { useMaxWidth } from '../../hooks/useResponsive';
import {
  formatRating,
  formatPricePerPeriod,
  getStateAbbr,
} from '../../utils/locations';
import LocationDetail from '../LocationDetail';
import { TransparentRow } from '../Row';
import { TextBodySmall, TextH4Big } from '../StyledText';
import { Divider } from '../Themed';
import Rating from '../reviews/Rating';

export default function LocationDetailsWrapper({
  locationNameId,
}: {
  locationNameId: string;
}) {
  const location = useLocation(locationNameId);

  const isMobileDevice = useMaxWidth(430);
  const isMediumDevice = useMaxWidth(1000);
  const theme = useColorScheme();

  if (!location) {
    return null;
  }

  return (
    <>
      <View
        style={[
          !isMediumDevice && styles.detailsLarge,
          !isMediumDevice && {
            shadowRadius: 12,
            shadowOpacity: 0.8,
            shadowColor: Colors[theme].shadow,
          },
        ]}
      >
        {isMobileDevice && (
          <TextH4Big style={styles.detailsTitle}>{location.name}</TextH4Big>
        )}
        <View style={isMobileDevice && styles.location}>
          <Image
            style={[styles.image, isMediumDevice && styles.imageMobile]}
            source={location.images[0]?.toString() as ImageSourcePropType}
          />
          {!isMobileDevice && (
            <TextH4Big style={styles.detailsTitle}>{location.name}</TextH4Big>
          )}
          <LocationDetails location={location} />
        </View>
      </View>
      {isMediumDevice && (
        <Divider style={[styles.divider, { width: '100%' }]} />
      )}
    </>
  );
}

export function LocationDetails({ location }: { location: Location }) {
  const minimumPrice = location.price;
  return (
    <View style={styles.locationDetails}>
      {location?.reviews?.rating ? (
        <TransparentRow>
          <Rating rate={location.reviews.rating} />
          <TextBodySmall>
            {formatRating(location?.reviews?.rating)}
          </TextBodySmall>
        </TransparentRow>
      ) : null}
      {minimumPrice ? (
        <LocationDetail
          style={styles.locationDetail}
          icon="priceTag"
          text={formatPricePerPeriod(minimumPrice, 'hour', '+')}
        />
      ) : null}
      <LocationDetail
        style={styles.locationDetail}
        icon="location"
        text={`${location.address?.city}, ${getStateAbbr(location.address?.state)}`}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  detailsLarge: {
    width: 445,
    paddingHorizontal: 30,
    paddingVertical: 40,
    borderRadius: 10,
    marginRight: 55,
  },
  detailsTitle: {
    marginTop: 10,
  },
  location: {
    marginTop: 15,
    gap: 10,
    flexDirection: 'row',
  },
  image: {
    borderRadius: 10,
    width: 385,
    height: 200,
  },
  imageMobile: {
    width: 150,
    height: 100,
  },
  divider: {
    marginVertical: 30,
  },
  locationDetails: {
    marginTop: 10,
    alignItems: 'flex-start',
  },

  locationDetail: {
    marginTop: 5,
  },
});
